import './index.css'

import { ThemeProvider } from '@material-ui/styles'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import reportWebVitals from './reportWebVitals'
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'

if (window.location.pathname === '/silent_renew') {
  // Render ONLY the lightweight silent renew component in the hidden iframe.
  // Avoids loading Redux and the main app which would start their own
  // oidc-client-ts instances and trigger an exponential loop of nested iframes.
  import('./presentation/SilentRenew')
    .then(({ default: SilentRenew }) => {
      ReactDOM.render(<SilentRenew />, document.getElementById('root'))
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load SilentRenew component:', error)
    })
} else {
  // Initiate user loading immediately after the store is ready.
  // If the user has a valid session in localStorage, it is dispatched to Redux.
  // If not, or if the token has expired, a signinRedirect() to the Retain IdP is
  // triggered. On the /callback path, the OIDC code exchange is processed first.
  Promise.all([
    import('./App'),
    import('./authentication/authenticationHandlers'),
    import('./redux'),
    import('./themes'),
  ])
    .then(
      ([
        { default: App },
        { loadUser },
        { default: store },
        { default: themes },
      ]) => {
        loadUser(store, window.location.pathname, window.localStorage)

        ReactDOM.render(
          <Provider store={store}>
            <ThemeProvider theme={themes.default}>
              <App />
            </ThemeProvider>
          </Provider>,
          document.getElementById('root'),
        )
      },
    )
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load application components:', error)
      ReactDOM.render(
        <div
          style={{
            padding: '2rem',
            textAlign: 'center',
            fontFamily: 'sans-serif',
          }}
        >
          <h2>Application Error</h2>
          <p>
            Failed to load essential components. Please check your network
            connection and refresh the page.
          </p>
        </div>,
        document.getElementById('root'),
      )
    })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
// serviceWorkerRegistration.register()
